import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

function Problems() {
  return (
    <section className="intro_section p-100">
      <Container>
        <Row>
          <Col xs={12} md={5} lg={5} xl={5} xxl={5} className="my-auto ">
            <h2 style={{ color: "#000" }}>
              The <span style={{ color: "#259354" }}>Problem</span>
            </h2>
            <p>
              The major concern with the app was to make it simple enough for
              farmers to use on a regular basis. The features and functions of
              the app were required to represent the needs of the niche and
              offer them unmatched value.
            </p>
          </Col>
          <Col
            xs={12}
            md={7}
            lg={6}
            xl={6}
            xxl={6}
            className="my-auto text-center offset-lg-1 "
          >
            <StaticImage
              src="../../../images/case-studies/martbook/problem_img.webp"
              alt="TekRevol"
              layout="constrained"
              placeholder="blurred"
              formats={["webp"]}
              width={892}
              height={896}
            />
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Problems;
